import appConstants from "../../constants";

const SERVICE_URL = `${appConstants.SERVICE_REQUEST_GOOGLE_GEOLOCATION_GEOLOCATE_URL}`;

export default async function getGoogleGeoLocation() {

  try {
    const response =
      await fetch(
        `${SERVICE_URL}?key=${appConstants.SERVICE_REQUEST_GOOGLE_GEOLOCATION_GEOLOCATE_API_KEY}`,
        appConstants.SERVICE_REQUEST_GOOGLE_GEOLOCATION_GEOLOCATE_CONFIG
      );

    // verify response status
    if (!response.ok) {
      const errorMessage = `An error has occurred: ${response.status}`;
      console.warn(errorMessage);
      return {
        hasError: true,
        errorMessage: errorMessage,
        coordinates: null
      };
    }

    const data = await response.json();

    if (
      ('location' in data) &&
      ('lat' in data.location) &&
      ('lng' in data.location)
    ) {
      return {
        hasError: false,
        errorMessage: null,
        coordinates: {
          latitude: data.location.lat,
          longitude: data.location.lng,
        }
      };
    }
    else {
      const errorMessage = `Device latitude and longitude could not be detected or retrieved.`;
      console.warn(errorMessage);
      return {
        hasError: true,
        errorMessage: errorMessage,
        coordinates: null
      };
    }
  } catch (exception) {
    const errorMessage = `An error has occurred: ${exception.message}`;
    console.warn(errorMessage);
    return {
      hasError: true,
      errorMessage: errorMessage,
      coordinates: null
    };
  }
}


console.error('Device latitude and longitude could not be detected or retrieved.');
